// Create TC var template
window.tc_vars = {
  // Environment
  env_brand: 'SOMFY',
  env_channel: 'B2B',
  env_template: 'transactionTracker',
  env_section: 'transactionTracker',
  env_platform: 'SomfyOrders_V1',
  env_work: process.env.NODE_ENV,
  env_country: 'France',
  env_language: 'FR-FR',
  env_currency: 'EUR',

  // User information (when logged)
  user_id: '',
  user_email: '',
  user_groups: '',
  user_returning: 'true',

  // Page
  page_menu_name: 'none',
  page_cat_name: 'none',
  page_cat_name_local: 'none',
  page_name: document.title,

  // Search results
  search_keywords: '',
  search_category: '',
  search_type: '',
  search_technology: '',
  search_range: '',

  // Product information
  range_id: '',
  range_name: '',
  range_url: '',
  product_id: '',
  product_name: '',
  product_unit_price: '',
  product_url: '',
  product_url_img: '',
  product_is_obsolete: '',
  product_category: '',
  product_type: '',

  // Basket and conversion information
  pin_box: '',
  box_label: '',
  box_purpose: '',
  box_enduser_email: ''
}

export function injectTagCommanderScripts () {
  // Inject scripts for Tag Commander
  const scriptsToInject = {
    head: [],
    body: []
  }

  if (process.env.NODE_ENV === 'production') {
    scriptsToInject.head.push('https://cdn.tagcommander.com/3887/tc_Somfy_20.js?cachebuster')
    scriptsToInject.body.push('https://cdn.tagcommander.com/3887/tc_Somfy_21.js?cachebuster')
    scriptsToInject.body.push('https://cdn.tagcommander.com/3887/tc_Somfy_34.js?cachebuster')
  }
  else {
    scriptsToInject.head.push('https://cdn.tagcommander.com/3887/uat/tc_Somfy_20.js?cachebuster')
    scriptsToInject.body.push('https://cdn.tagcommander.com/3887/uat/tc_Somfy_21.js?cachebuster')
    scriptsToInject.body.push('https://cdn.tagcommander.com/3887/uat/tc_Somfy_34.js?cachebuster')
  }

  for (let [element, scripts] of Object.entries(scriptsToInject)) {
    for (let scriptUrl of scripts) {
      const scriptTag = document.createElement('script')
      scriptTag.src = scriptUrl
      document.getElementsByTagName(element)[0].appendChild(scriptTag)
    }
  }
}

export function eventsGlobal (type, data) {
  tc_events_global(window, type, data)
}

export function containerReload (type, data) {
  window.tc_vars[type] = data

  if (window['tC'] !== undefined) {
    tC.container.reload({
      events: {
        all: [{}, {}]
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/tagcommander.js